/**
 * المظهر داخل المنصة: نهاريٌّ (أبيض) افتراضاً بعد الدخول، وللمستخدم مبدّل
 * (قرار 18 سبتمبر 2026 — حلّ محلّ «ليليةٌ دائماً» في 13 سبتمبر). وخارج المنصة
 * — الموقع العام وصفحات الدخول وبوابة الطفل — ليليٌّ دائماً بلا خيار.
 */
export type Theme = 'light' | 'dark';
export const THEME_STORAGE_KEY = 'rafrafa.theme';

export function isTheme(v: unknown): v is Theme {
  return v === 'light' || v === 'dark';
}

/** ما يقرؤه `boot.js` أيضاً: أي قيمةٍ غير `dark` تعني النهاري */
export function storedTheme(): Theme {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}
